import BaseAction from "./BaseAction";
import CustomerReviewModalReducer from "@common/redux/reducers/CustomerReviewModalReducer";

class CustomerReviewModalAction extends BaseAction {
  open = async (selectedSummaryRecord) => {
    this.dispatch({
      open: true,
      selectedSummaryRecord,
      selectedCustomer: selectedSummaryRecord,
    });
  };
  close = this.reset;
}

const action = new CustomerReviewModalAction(CustomerReviewModalReducer);

export default action;
